import axios from 'axios'
import store from '@/plugins/store'


const mainApiAxios = axios.create({
    baseURL: process.env.VUE_APP_MAIN_API,
    timeout: 500000,
    headers: {
        'Accept': 'application/json; charset=utf-8',
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '-1',
    },
})

mainApiAxios.interceptors.request.use(
    (config) => {
        const token = store.getters['user/token']
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    },
)

mainApiAxios.interceptors.response.use(
    (res) => {
        if (res.config.responseType === 'blob') {
            return res
        }

        return res.data

    },
    async (error) => {

        if (error.response.status === 401 && typeof error.response.data.success == 'undefined') {

            store.dispatch('user/removeUserSession')
            if (window.location.pathname != '/login') {
                window.location.replace('/')
            }
        }
        if (error.response.status === 401 && error.response.data.success == false) {
            window.location.replace('/PageNotFound')
        }
        return Promise.reject(error)
    },
)



export { mainApiAxios }